export interface SubNode {
  Id: string;
  Name: string;
  ParentId: string;
  ParentName: string;
  Text: string;
  ItemId: string | null;
  InventDimId: string | null;
  ImageFilename: string;
  ImageFilepath: string;
  IsItemNew: boolean;
  Type: number;
  SubNodes: SubNode[] | null;

  shouldRender: boolean
}

export interface InventProductGroupBOM {
  // Composite Key
  PARENTPRODUCTGROUPID: string;   // StringLength(30)
  CHILDPRODUCTGROUPID: string;    // StringLength(30)
  DATAAREAID: string;             // StringLength(4)

  // Entity Properties
  Title?: string;
  ImagePath?: string;

  // AxEntity infrastructure (typically from AX)
  RECVERSION: number;
  RECID: number;

  // Navigation Property (flattened inline type)
  DataArea: {
    ID: string;           // StringLength(4)
    NAME: string;         // StringLength(40)
    ISVIRTUAL: number;
    ALWAYSNATIVE: number;
    TIMEZONE: number;

    RECVERSION: number;
    RECID: number;
  };
}

export class GroupNode {
    GroupId: string = '';
    GroupName: string = '';
    SelectedNodeId: string = '';
    SelectedNodeName: string = '';
    SelectedIsItem: boolean = false;
    ListIndex: number = 0;
    SelectedItemId: string = '';
    SelectedItemInventDimId: string = '';

    constructor(init?: Partial<GroupNode>) {
        if (init) {
            Object.assign(this, init);
        }
    }
}

export enum NodeTypes {
    Root = 0,
    Group = 1,
    Item = 2,
}

export interface CatalogueSearchItem {
  label: string;
  value: string | null;
  node: SubNode;
  groupNodes: GroupNode[];
}
